<ng-container *ngFor="let checklist of upaChecklists">
  <app-components-checklist [header]="getHeader(checklist)" [(checklist)]="checklist.Checklist"
    [(validationApi)]="validationApi" [isReadOnly]="isReadOnly" [hidePassedAnswers]="hidePassedAnswers"
    [hideFailedAnswers]="hideFailedAnswers" [hideSecondaryAnswers]="hideSecondaryAnswers"
    [displayNotesInline]="displayNotesInline"></app-components-checklist>
</ng-container>